<div class="contact-beneficiary">
  <app-avatar size="30px" [name]="fundraiser?.beneficiaryname?.info_1" [image]="fundraiser?.media_beneficiary?.cdn_path"></app-avatar>
  <div class="name-contact">
    <div class="name">{{fundraiser?.beneficiaryname?.info_1}}</div>
    <button (click)="openDialog()" mat-button>Contact Beneficiary</button>
  </div>
</div>